import { Card } from "@/shared/ui/Card";

const TASTO =
  "rounded-full border border-ink bg-ink px-4 py-1.5 text-[12.5px] font-semibold text-on-ink transition-[filter] hover:brightness-125 disabled:opacity-50";

/** Lista vuota: in caricamento, filtri a vuoto (ci sono ordini) o archivio
 *  vuoto. Audit 2026-05-19 (Davide «non vedo gli ordini pronti»): «archivio
 *  vuoto / Scarica da Poleepo» compariva anche con centinaia di ordini che
 *  non passavano i filtri, e invitava a sincronizzare a sync gia' in corso. */
export function OrdiniVuoto({
  caricamento,
  inArchivio,
  onMostraTutti,
  syncBusy,
  onSync,
}: {
  caricamento: boolean;
  /** Ordini in archivio; 0 = archivio vuoto. */
  inArchivio: number;
  onMostraTutti: () => void;
  syncBusy: boolean;
  onSync: () => void;
}) {
  const [titolo, testo, tasto] = caricamento
    ? ["Caricamento ordini", <>Lettura dal database…</>, null]
    : inArchivio > 0
      ? [
          "Nessun ordine per i filtri attivi",
          <>
            Ci sono <strong className="text-ink">{inArchivio}</strong> ordini in archivio, ma
            nessuno corrisponde ai filtri o alla ricerca correnti.
          </>,
          <button type="button" onClick={onMostraTutti} className={TASTO}>
            Mostra tutti gli ordini
          </button>,
        ]
      : [
          "Nessun ordine in archivio",
          <>
            Premi <strong className="text-ink">Sincronizza</strong> qui sopra: il worker scarica da
            Poleepo in background e la lista si aggiorna da sola.
          </>,
          <button type="button" onClick={onSync} disabled={syncBusy} className={TASTO}>
            {syncBusy ? "Avvio…" : "Scarica ordini da Poleepo"}
          </button>,
        ];
  return (
    <Card className="py-8 text-center">
      <h3 className="mb-1 font-display text-[16px] font-bold text-ink">{titolo}</h3>
      <p className="mx-auto mb-4 max-w-[480px] text-[12.5px] text-ink-2">{testo}</p>
      {tasto}
    </Card>
  );
}
